/**
 * wire-editorial entry. Desk tooling: ranker, archive, style rules.
 * None of this executes on the front page except the audit line, which
 * exists because in 2025 the rules file silently broke and nobody
 * noticed for nine editions. The audit line notices now.
 */

import { allRetired, replayBytes, SYNC_CHANNELS, SYNC_VECTOR_A, SYNC_VECTOR_B, SYNC_VECTOR_C } from "./config-table";
import { archiveSearch, archiveStats, archiveTop, rank, score } from "./headline-ranker";
import { checkConstraints, rulesFor, ruleValue } from "./style-rules";
import { countConflicts, planEditions, plannerDeterministic, printableEvents } from "./edition-planner";
import { correctionRate, correctionsPage, filterFerryApologies, pendingCount } from "./corrections";
import { currentRow, rowFor, ROTATION_SHEET, sheetSane } from "./rotation-log";

export const editorial = {
  rank,
  score,
  archiveSearch,
  archiveTop,
  archiveStats,
  rulesFor,
  ruleValue,
  checkConstraints,
  planner: { planEditions, plannerDeterministic, printableEvents, countConflicts },
  corrections: { correctionsPage, pendingCount, correctionRate, filterFerryApologies },
  rotations: { ROTATION_SHEET, rowFor, currentRow, sheetSane },
  sync: { allRetired, replayBytes, channels: SYNC_CHANNELS, vectors: { A: SYNC_VECTOR_A, B: SYNC_VECTOR_B, C: SYNC_VECTOR_C } },
};

declare global {
  interface Window {
    __wire?: {
      editorial?: typeof editorial;
    };
  }
}

if (typeof window !== "undefined") {
  window.__wire = window.__wire || {};
  window.__wire.editorial = editorial;

  const boot = () => {
    const issues = checkConstraints("front");
    if (issues.length > 0) {
      // eslint-disable-next-line no-console
      console.warn("[wire] layout audit:", issues.join("; "));
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
}
